import { CookieConsentType } from '../models/cookie-consent-type.enum';
import { store } from '../store';

export function hasGivenConsentFor(cookieConsentType: CookieConsentType) {
  const consent = store.get('consent');

  return consent?.includes(cookieConsentType) === true;
}
